var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-gene-lab-order',{staticClass:"pt-gene-lab-order__page",attrs:{"isPrimaryUser":_vm.isPrimaryUser}})}
var staticRenderFns = []

export { render, staticRenderFns }